export enum CompanySubscriptionStatus {
  Trial,
  Active,
  PastDue,
  Cancelled,
}
